
import { useState } from 'react';
import { useTelegramWebApp } from '@/hooks/useTelegramWebApp';
import { useTelegramAuth } from '@/hooks/useTelegramAuth';

export interface BroUser {
  id: string;
  brocode: string;
  rank: string;
  bro_score: number;
  telegram_id: string | null;
  wallet_address?: string;
  is_brometheus: boolean;
}

export const useMiniAppUser = () => {
  const { isTelegram } = useTelegramWebApp();
  const { user, isAuthenticated, isLoading, error, retryAuth, initData } = useTelegramAuth();
  const [retryCount, setRetryCount] = useState(0);

  const handleRetryWithBackoff = () => {
    setRetryCount(prev => prev + 1);
    const delay = Math.min(1000 * Math.pow(2, retryCount), 10000); // Exponential backoff, max 10s
    
    setTimeout(() => {
      retryAuth();
    }, delay);
  };

  // For web version (non-Telegram), allow access but mark as not authenticated
  if (!isTelegram) {
    return {
      user: null,
      isAuthenticated: false,
      isLoading: false,
      error: null, // Don't show error for web access - let the components handle it
      isTelegram,
      retryCount,
      handleRetryWithBackoff,
      initData: null
    };
  }

  // For Telegram version, return the authentication state
  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    isTelegram,
    retryCount,
    handleRetryWithBackoff,
    initData
  };
};
